"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Fuze = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
 * @file Fuze 队列控制
 * @author qiaogang
 * @date 2020-01-30
 */

/**
 * 队列控制
 * @example:
 *
 * let fuze = new Fuze();
 *
 * fuze.add(() => {
 *   // 添加待执行动作，如果队列完成，则立刻执行；如果队列为完成，则等待 fire 后执行。
 * });
 *
 * // 执行队列
 * fuze.fire();
 */
var Fuze = /*#__PURE__*/function () {
  function Fuze() {
    _classCallCheck(this, Fuze);

    this._queue = []; // 0: 未执行；1：执行中；2：执行完成

    this._fired = 0;
  }
  /**
   * 执行队列
   */


  _createClass(Fuze, [{
    key: "fire",
    value: function fire() {
      var item;

      while (this._queue.length > 0 && (item = this._queue.shift())) {
        // JS 中执行中的逻辑其实没用，因为 JS 会阻塞线程。但这里为了逻辑状态的一致，保留执行中的状态，去掉与否对业务无影响。
        this._fired = 1;
        var _item = item,
            fn = _item.fn,
            options = _item.options;
        var context = options.context,
            _options$args = options.args,
            args = _options$args === void 0 ? [] : _options$args;

        try {
          fn.apply(context, args);
        } catch (err) {
          /* eslint-disable no-console */
          console.error(err);
        }
      }

      this._fired = 2;
    }
    /**
     * 将制定 fn 加入队列
     * @param {Function} fn 指定函数
     * @param {Object=} options 参数
     * @options {Object=} options.context fn 函数的 context 上下文
     * @options {Array=} options.args fn 函数的指定参数
     * @returns {Fuze}
     */

  }, {
    key: "add",
    value: function add(fn) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (typeof fn !== 'function') {
        return this;
      }

      if (this._fired === 2) {
        var context = options.context,
            _options$args2 = options.args,
            args = _options$args2 === void 0 ? [] : _options$args2;
        fn.apply(context, args);
      } else {
        this._queue.push({
          fn: fn,
          options: options
        });
      }

      return this;
    }
  }, {
    key: "length",
    value: function length() {
      return this._queue.length;
    }
    /**
     * 清空队列
     */

  }, {
    key: "clear",
    value: function clear() {
      this._queue = [];
    }
    /**
     * 重置队列状态
     */

  }, {
    key: "reset",
    value: function reset() {
      this._fired = 0;
    }
  }]);

  return Fuze;
}();

exports.Fuze = Fuze;